import { render, staticRenderFns } from "./ZDMInspectors.vue?vue&type=template&id=bf3609fe&scoped=true&"
import script from "./ZDMInspectors.vue?vue&type=script&lang=js&"
export * from "./ZDMInspectors.vue?vue&type=script&lang=js&"
import style0 from "./ZDMInspectors.vue?vue&type=style&index=0&id=bf3609fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3609fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
